import React, { useEffect } from "react";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { getStudentByIdAPI } from "../../../redux/features/adminSlice";
import InstructorDetailsComponent from "../../../components/InstructorDetails/InstructorDetails";
import { resetError } from "../../../redux/features/adminSlice";
import Notification from "../../../components/Notification/Notification";
import AdminNotification from "../../../components/Notification/AdminNotification";
import InstructorNotification from "../../../components/Notification/InstructorNotification";

export default function Profile() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const { loading, error } = useSelector((state) => state.admin);
  useEffect(() => {
    navigate(`/profile?id=${auth.user_id}`);
  }, []);

  useEffect(() => {
    dispatch(getStudentByIdAPI({ token: auth.token, userId: auth.user_id }))
      .unwrap()
      .catch((error) => {
        const errorMessage =
          typeof error === "string"
            ? error
            : error?.message || "Failed to fetch student details.";
        toast.error(errorMessage, { position: "top-center" });
      });

    return () => {
      dispatch(resetError());
    };
  }, [auth?.token, auth.user_id, dispatch, navigate]);
  return (
    <>
    {loading && (
      <div className="loader-container">
        <div className="dotted-loading theme-color"></div>
      </div>
    )}
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3 className="ad-heading-04 fw-bold mb-8">Profile</h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            {auth.role === "Admin" ? (
              <AdminNotification />
            ) : auth.role === "Instructor" ? (
              <InstructorNotification />
            ) : auth.role === "Student" ? (
              <Notification />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <InstructorDetailsComponent userId={auth.user_id} />
    </>
  );
}
